import React from 'react';

import { renderWhenTrue } from '../../utils';

import {
  Container,
  HeaderSection,
  PrimaryHeaderMain,
  PrimaryHeaderAdditional,
  SecondaryHeaderMain,
  SecondaryHeaderImage,
  ContentContainer,
  InnerContainer,
  HeadersContainer,
} from './sectionContainer.styled';
import { SectionContainerData } from './sectionContainer.types';
import { ContentWidth } from './sectionContainer.enums';
import { DynamicContentHeaderType } from '../../enums/dynamicContentHeaderType.enum';

export const SectionContainer: React.FC<SectionContainerData> = (data: SectionContainerData) => {
  const {
    header,
    subheader,
    smallHeader,
    smallHeaderImage,
    headerType,
    children,
    isGridModeEnable,
    fullContentWidthOnMobile,
    contentWithMode,
    className,
    spaceBetween,
    renderCaseStudyProduct,
  } = data;
  const isPrimaryHeaderVisible = (!!header || !!subheader) && !(headerType && headerType === DynamicContentHeaderType.SmallImageHeader);
  const isSecondaryHeaderVisible = (!!smallHeader || !!smallHeaderImage) && !(headerType && headerType === DynamicContentHeaderType.BigTextHeader);

  const renderPrimaryHeaderMain = renderWhenTrue(() => <PrimaryHeaderMain>{header}</PrimaryHeaderMain>);

  const renderPrimaryHeaderAdditional = renderWhenTrue(() => <PrimaryHeaderAdditional>{subheader}</PrimaryHeaderAdditional>);

  const renderPrimaryHeader = renderWhenTrue(() => (
    <>
      {renderPrimaryHeaderMain(!!header)}
      {renderPrimaryHeaderAdditional(!!subheader)}
    </>
  ));

  const renderSecondaryHeaderMain = renderWhenTrue(() => <SecondaryHeaderMain>{smallHeader}</SecondaryHeaderMain>);

  const renderSecondaryHeaderImage = renderWhenTrue(() => (
    <SecondaryHeaderImage
      src={smallHeaderImage?.localFile?.url}
      alt=''
    />
  ));

  const renderSecondaryHeader = renderWhenTrue(() => (
    <>
      {renderSecondaryHeaderMain(!!smallHeader)}
      {renderSecondaryHeaderImage(!!smallHeaderImage)}
    </>
  ));

  const renderProductSection = renderWhenTrue(() => (renderCaseStudyProduct()));
  
  return (
    <Container spaceBetween={spaceBetween}>
      <InnerContainer
        fullContentWidthOnMobile={fullContentWidthOnMobile}
        className={className}
      >
        <HeadersContainer>
          {renderProductSection(!!renderCaseStudyProduct)}
          <HeaderSection fullContentWidthOnMobile={fullContentWidthOnMobile}>
            {renderPrimaryHeader(isPrimaryHeaderVisible)}
            {renderSecondaryHeader(isSecondaryHeaderVisible)}
          </HeaderSection>
        </HeadersContainer>
        <ContentContainer
          isGridModeEnable={isGridModeEnable}
          widthMode={contentWithMode || ContentWidth.Restricted}
          className='content-container'
        >
          {children}
        </ContentContainer>
      </InnerContainer>
    </Container>
  );
}
